import { Link, LinkProps } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

export const LocalizedLink = ({ to, children, ...props }: LocalizedLinkProps) => {
  const { getLocalizedPath } = useLanguage();
  
  // Don't localize external links or hash links
  if (to.startsWith('http') || to.startsWith('#') || to.startsWith('mailto:') || to.startsWith('tel:')) {
    return <Link to={to} {...props}>{children}</Link>;
  }
  
  return (
    <Link to={getLocalizedPath(to)} {...props}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
